import React, { useState, useContext, useEffect } from 'react';
import MobileHeader from './MobileHeader';
import MobileBottomNav from './MobileBottomNav';
import TransactionModal from './TransactionModal';
import TransferModal from './TransferModal';
import DraggableChatButton from './DraggableChatButton';
import TrialBanner from './TrialBanner';
import { AuthContext } from '@/App';
import { useLocation } from 'react-router-dom';

const MobileLayout = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState('expense');
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenModal = (e) => {
      if (e.detail?.type) {
        setSelectedType(e.detail.type);
      }
      setIsTransactionModalOpen(true);
    };
    const handleOpenTransfer = () => {
      setIsTransactionModalOpen(false);
      setIsTransferModalOpen(true);
    };

    window.addEventListener('open-transaction-modal', handleOpenModal);
    window.addEventListener('open-transfer-modal', handleOpenTransfer);
    return () => {
      window.removeEventListener('open-transaction-modal', handleOpenModal);
      window.removeEventListener('open-transfer-modal', handleOpenTransfer);
    };
  }, []);

  const getTitle = () => {
    switch (location.pathname) {
      case '/dashboard': return 'Portal de Gastos';
      case '/transactions': return 'Mis Movimientos';
      case '/statistics': return 'Estadísticas';
      case '/profile': return 'Mi Perfil';
      case '/categories': return 'Categorías';
      case '/accounts': return 'Cuentas';
      case '/goals': return 'Objetivos';
      default: return 'PGastos';
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header Fijo */}
      <MobileHeader title={getTitle()} />

      {/* Espaciador para el Header — altura dinámica con safe-area */}
      <div style={{ height: 'calc(env(safe-area-inset-top) + 4rem)' }} />

      {/* Banner de Trial */}
      <TrialBanner />

      {/* Contenido Principal */}
      <main className="flex-1 px-4 pb-24 pt-4">
        {children}
      </main>

      {/* Chat IA Flotante Arrastrable (Solo Premium/Pro) */}
      {user && (user.subscription_tier === 'premium' || user.subscription_tier === 'pro') && (
        <DraggableChatButton />
      )}

      {/* Navegación Inferior con FAB */}
      <MobileBottomNav onAddClick={() => setIsTransactionModalOpen(true)} />

      {/* Modal de Transacción (FAB) */}
      <TransactionModal 
        isOpen={isTransactionModalOpen} 
        onClose={() => setIsTransactionModalOpen(false)}
        preselectedType={selectedType}
        onSuccess={() => {
          window.dispatchEvent(new CustomEvent('transaction-added'));
        }}
      />

      {/* Modal de Transferencia */}
      <TransferModal
        isOpen={isTransferModalOpen}
        onClose={() => setIsTransferModalOpen(false)}
        onSuccess={() => {
          window.dispatchEvent(new CustomEvent('transaction-added'));
        }}
      />
    </div>
  );
};

export default MobileLayout;
